import { render, staticRenderFns } from "./DashboardDoctorView.vue?vue&type=template&id=48034d0c&scoped=true"
import script from "./DashboardDoctorView.vue?vue&type=script&lang=js"
export * from "./DashboardDoctorView.vue?vue&type=script&lang=js"
import style0 from "./DashboardDoctorView.vue?vue&type=style&index=0&id=48034d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48034d0c",
  null
  
)

export default component.exports